import { render } from "./addtable.vue?vue&type=template&id=cc084b0a"
import script from "./addtable.vue?vue&type=script&lang=js"
export * from "./addtable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__